import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useMst } from '../../models';
import contents from '../../routes/contentRoutes';
import { observer } from 'mobx-react';

const PAGE_404 = lazy(() => import('../../pages/presentation/auth/Page404'));
const ContentRoutes = () => {
	const { user: user } = useMst();

	return (
		<Routes>
			{contents.map((page) => {
				// if (user.me.cocd === '2') {
				// 	// eslint-disable-next-line react/jsx-props-no-spreading
				// 	return page.id !== 'dc' && <Route key={page.path} {...page} />;
				// } else {
					return (
						// eslint-disable-next-line react/jsx-props-no-spreading
						<Route key={page.path} {...page} />
					);
				// }
			})}
			<Route path='*' element={<PAGE_404 />} />
		</Routes>
	);
};

export default observer(ContentRoutes);
